import { FunctionComponent } from 'react';
import classnames from 'classnames';

// Contexts
import { useCategory } from '@Components/Categories/Context';
import { useViewDetected } from '@Components/Utils/ViewDetected';

// styles
import styles from './Tabs.module.scss';
import Anchor from '@Components/Utils/Anchor';

interface TabsProps {
    className?: string;
    categoryId?: string;
}

const Tabs: FunctionComponent<TabsProps> = ({ categoryId, className }) => {
    const { categories } = useCategory();
    const { deviceType } = useViewDetected();

    const renderCategory = () => {
        return categories.map((category) => {
            const categoryClassName = classnames([
                styles.tab,
                {
                    [styles.active]: category.id === categoryId,
                },
            ]);
            return (
                <Anchor href={`/bai-viet/danh-muc/${category.slug}`} key={`tab-item-${category.id}`} className={categoryClassName}>
                    {category.title}
                </Anchor>
            );
        });
    };

    const wrapperClassName = classnames([
        styles.tabs,
        {
            [styles.mobile]: ['mobile', 'tablet'].includes(deviceType),
        },
        className,
    ]);

    return (
        <div className={wrapperClassName}>
            <Anchor
                href="/bai-viet/tim-kiem"
                className={classnames([
                    styles.tab,
                    {
                        [styles.active]: !categoryId,
                    },
                ])}
            >
                Tất cả
            </Anchor>
            {renderCategory()}
        </div>
    );
};

Tabs.defaultProps = {
    className: '',
};

export default Tabs;
